import { render, staticRenderFns } from "./lockDetailpage.vue?vue&type=template&id=0f58ff08&scoped=true"
import script from "./lockDetailpage.vue?vue&type=script&lang=js"
export * from "./lockDetailpage.vue?vue&type=script&lang=js"
import style0 from "./lockDetailpage.vue?vue&type=style&index=0&id=0f58ff08&prod&lang=less&scoped=true"
import style1 from "./lockDetailpage.vue?vue&type=style&index=1&id=0f58ff08&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f58ff08",
  null
  
)

export default component.exports